import { styled } from '@mui/material/styles';

export const RootStyled = styled('div')(() => ({
  backgroundColor: '#000E1C',
  width: '100%',
  minHeight: '100%',
  padding: '40px 140px',
}));
